import { formatDateInAppTimezone, formatDatePartsInAppTimezone } from "./timezone";

export function formatarCpf(cpf: string | number | null | undefined): string {
  const cpfStr = String(cpf || "");
  const numerosCpf = cpfStr.replace(/\D/g, "");

  if (numerosCpf.length !== 11) {
    return numerosCpf;
  }

  return numerosCpf.replace(/^(\d{3})(\d{3})(\d{3})(\d{2})$/, "$1.$2.$3-$4");
}

export function formatarCnpj(cnpj: string | number | null | undefined): string {
  const cnpjStr = String(cnpj || "");
  const numerosCnpj = cnpjStr.replace(/\D/g, "");

  if (numerosCnpj.length !== 14) {
    return numerosCnpj;
  }

  return numerosCnpj.replace(
    /^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})$/,
    "$1.$2.$3/$4-$5",
  );
}

export function formatarDataDbParaBr(data: string | null | undefined): string {
  if (!data || typeof data !== "string" || data.trim() === "") {
    return "";
  }

  const dataLimpa = data.trim();
  const match = dataLimpa.match(/^(\d{4})-(\d{2})-(\d{2})$/);

  if (!match) {
    return data;
  }

  const [, ano, mes, dia] = match;

  return `${dia}/${mes}/${ano}`;
}

export function formatarDatetimeToDataBr(dataString: string | undefined | null): string | undefined {
  if (!dataString) {
    return "";
  }

  return formatDateInAppTimezone(dataString, {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
  });
}

export function formatarDatetimeToDataDb(dataOriginal: Date | string | undefined): string {
  if (!dataOriginal) {
    return "";
  }

  const parts = formatDatePartsInAppTimezone(dataOriginal);

  if (!parts) {
    throw new Error("Data inválida");
  }

  return `${parts.year}-${parts.month}-${parts.day}`;
}

export function formatarHoraBr(dataString: string | undefined | null): string {
  if (!dataString) {
    return "";
  }

  return formatDateInAppTimezone(dataString, {
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
  });
}

export function formatarDatetimeCompletoBr(dataString: string | undefined | null): string {
  if (!dataString) {
    return "";
  }

  const data = formatarDatetimeToDataBr(dataString);
  const hora = formatarHoraBr(dataString);

  return data && hora ? `${data} às ${hora}` : data || "";
}
